<template>
  <div class="marketplace">
    <table>
      <tr><td>Number of pros</td><td>{{numPros}}</td></tr>
      <tr><td>Num disabled</td><td>{{numDisabled}}</td></tr>
      <tr><td>Pros who got at least one task</td><td>{{prosWithTasks}} ({{Math.round(prosWithTasks/numPros*100)}}%)</td></tr>
      <tr><td>Number of orders</td><td>{{numOrders}}</td></tr>
      <tr><td>Number of fulfilled orders</td><td>{{fulfilledOrders}}({{Math.round(fulfilledOrders/numOrders * 100)}}%)</td></tr>
      <tr><td>Last 100 orders % complete</td><td>{{fulfilledOrdersPercentage}}%</td></tr>
      <tr><td>Avg time to accept task</td><td>{{avgTimeToAccept}}</td></tr>
      <tr><td>Avg time to reject</td><td>{{avgTimeToReject}}</td></tr>
      <tr><td>Avg time to accept order</td><td>{{avgTimeToAcceptOrder}}</td></tr>
      <tr><td>Order % 32 hours or less</td><td>{{Math.round(num32/numOrders * 100)}}|{{Math.round(num32Completed/num32 * 100)}}</td></tr>
    </table>
    <div id="users-table" class="data-table">
      <div class="header">
        <div>TOP priority PROs</div>
        <div>Priority</div>
        <div>Rating</div>
        <div>Tasks</div>
        <div>Responded</div>
        <div>Completed</div>
      </div>
      <div v-for="user in users" v-bind:key="user.id" class="row" v-bind:class="{ disabled: user.ordersDisabled }">
        <div class="cell id">
          <router-link :to="{ name: 'userProfile', params: { id: user.id } }">{{user.firstName}} {{user.lastName}}</router-link>
          <span v-if="user.ordersDisabled">[PAUSED]</span></div>
         <div class="cell">{{user.priority}}</div>
        <div class="cell">{{user.averageRating}}</div>
        <div class="cell">{{user.tasksAssigned}}</div>
        <div class="cell">{{user.tasksResponded}}<span v-if="user.tasksAssigned">({{Math.round(user.tasksResponded/user.tasksAssigned * 100)}}%)</span></div>
        <div class="cell">{{user.tasksCompleted}}<span v-if="user.tasksResponded">({{Math.round(user.tasksCompleted/user.tasksResponded * 100)}}%)</span></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
  table td {
    border: 1px solid black;
    padding: 10px;
  }
  #users-table{
    grid-template-columns: auto auto auto auto auto auto;
  }
</style>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from '../services/api';

export default {
  name: 'home',
  data: function() {
    return {
      users: [],
      filter: 'taskers',
      search: '',
      numPros: 0,
      prosWithTasks: 0,
      numOrders: 0,
      fulfilledOrders: 0,
      avgTimeToAccept: 0,
      avgTimeToReject: 0,
      num32: 0,
      num32Completed: 0,
      fulfilledOrdersPercentage: 0,
      avgTimeToAcceptOrder: 0,
      numDisabled: 0,
    }
  },
  methods: {
  },
  created: async function() {
    const users = (await api.getPros());
    const pros = (Object.keys(users).map(key => users[key]))
      .filter(u => (u.verified)).map((u, i) => ({...u, index: i})).sort(
      (u1, u2) => {
        const t1 = (u1.createdAt || {_seconds: 0})._seconds;
        const t2 = (u2.createdAt || {_seconds: 0})._seconds;
        return t2 - t1;
      }
    );
    const orders = (await api.getOrders()).filter(o => o.status != 'new' && o.status != 'confirmed' && o.status != 'new');
    let numAccepted = 0;
    let acceptTotal = 0;
    let orderAcceptTotal = 0;
    let numOrderAccepted = 0;
    let numRejected = 0;
    let rejectTotal = 0;
    let fulfilledOrders = 0;
    let num32 = 0;
    let num32Completed = 0;
    const skillsMap = {};
    const usersOrders = {};
    orders.forEach((order, i) => {
      if (!usersOrders[order.clientId]) {
        usersOrders[order.clientId] = {
          created: 1,
          completed: 0,
          createdAt: [order.createdAt._seconds * 1000]
        }
      } else {
        usersOrders[order.clientId].created++;
        usersOrders[order.clientId].createdAt.push(order.createdAt._seconds * 1000);
      }
      skillsMap[order.skillId] = skillsMap[order.skillId] || 0;
      skillsMap[order.skillId]++;
      if (order.status === 'completed') {
        fulfilledOrders++;
        usersOrders[order.clientId].completed++;
      }
      if (i === 99) {
        this.fulfilledOrdersPercentage = 0 + fulfilledOrders;
      }
      let assignedAt = false;
      let createdAt = order.createdAt;
      const createdAtTimestamp = createdAt._seconds * 1000;
      if (order.details.datetime.slots) {
        let minDateSlot = order.details.datetime.slots[0].timestamp;
        order.details.datetime.slots.forEach(slot => {
          if (slot.timestamp < minDateSlot) {
            minDateSlot = slot.timestamp;
          }
        });
        // console.log(minDateSlot, createdAtTimestamp, minDateSlot - createdAtTimestamp);
        if ((minDateSlot - createdAtTimestamp) / 1000 < 60 * 60 * 32) {
          num32++;
          if (order.status === 'completed') {
            num32Completed++;
          }
        }
      }
      let orderAccepted = false;
      (order.events || []).forEach(event => {
        if (event.type === 'assign') {
          assignedAt = event.publishedAt;
        } else if (assignedAt) {
          if (event.type === 'reject') {
            const diff = event.publishedAt._seconds - assignedAt._seconds;
            if (diff < 60 * 60) {
              rejectTotal += diff;
              assignedAt = false;
            }
            numRejected++;
          } else if (event.type === 'accept') {
            const diff = event.publishedAt._seconds - assignedAt._seconds;
            if (diff < 60 * 60) {
              acceptTotal += diff;
              numAccepted++;
            }
            if (!orderAccepted) {
              const diffOrder = event.publishedAt._seconds - createdAt._seconds;
              if (diff < 60 * 60 * 3) {
                orderAcceptTotal += diffOrder;
                numOrderAccepted++;
                orderAccepted = true;
              }
            }
            assignedAt = false;
          }
        }
      });
    });
    window.usersOrders = usersOrders;
    const allSkills = Object.keys(skillsMap).map(skillId => {
      return {id: skillId, numOrders: skillsMap[skillId], title: this.$store.state.skills[skillId].title};
    });
    console.log('POPULAR SKILLS', allSkills.sort((s1, s2) => {
      return s2.numOrders - s1.numOrders;
    }));
    this.num32 = num32;
    this.avgTimeToAccept = Math.round((acceptTotal / numAccepted) / 60);
    this.avgTimeToReject = Math.round((rejectTotal / numRejected) / 60);
    this.avgTimeToAcceptOrder = Math.round((orderAcceptTotal / numOrderAccepted) / 60);
    this.prosWithTasks = pros.reduce((prev, next) => {
      if (next.ordersDisabled) {
        this.numDisabled++;
      }
      if (next.tasksAssigned) {
        return ++prev;
      } else {
        return prev;
      }
    }, 0)
    this.numPros = pros.length;
    this.numOrders = orders.length;
    this.fulfilledOrders = fulfilledOrders;
    this.num32Completed = num32Completed;
    this.users = pros.sort((a, b) => {
      return (b.priority || 0) - (a.priority || 0)
    });
    // console.log(this.users);
    // console.log(this.orders.map((order, i) => ({...order, id: i})));
  },
  // components: {
  //   HelloWorld
  // }
}
</script>
